module.exports = __webpack_public_path__ + "img/c263b63.svg";